<template>
	<div class="banner-wrapper">
		<div class="label-pseudo-wrapper">
			<div class="label-wrapper">
				<div class="label">Total Cash</div>
			</div>
		</div>
		<div class="amount-pseudo-wrapper">
			<div class="amount-wrapper">
				<div class="amount">{{ formattedUnallocatedBalance }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { currencyFormatter } from "@/lib/formatters";

export default {
	name: 'AccountBanner',
	computed: {
		...mapGetters("game/budgets", ["unallocated"]),
		formattedUnallocatedBalance() {
			return currencyFormatter.format(this.unallocated);
		},
	},
};
</script>

<style lang="scss" scoped>
	.banner-wrapper {
		text-align: center;
	}

	.label-wrapper,
	.amount-wrapper {
		display: inline-block;
		position: relative;
		filter: drop-shadow( -5px 5px 0px $body-txt-color);
		// TODO: filter is not supported by IE11, find alternative
	}

	.label-wrapper { z-index: $z-bottom-mid; }

	.amount-wrapper {
		width: 200px;
		margin-left: -20px;
		z-index: $z-bottom;

		@include tablet { width: 400px; }
		@include desktop { width: 500px; }
		@include desktop-sm { width: 400px; }
	}

	.label {
		background: $alt-color;
		color: $body-txt-color;
		font-family: $body-font-script;
		font-size: $font-size-sm;
		letter-spacing: $letter-spacing-script;
		line-height: $line-height-script;
		text-transform: uppercase;
		text-align: center;
		box-sizing: content-box;
		width: 5ch;
		padding: 1.25ch 2ch;
		clip-path: polygon(6% 0, 100% 4%, 100% 95%, 0% 100%);
		-webkit-clip-path: polygon(6% 0, 100% 4%, 100% 95%, 0% 100%);
		transform: translateY(-5px);
		z-index: $z-bottom-mid;

		@include tablet { font-size: $font-size-x-lg; }
		@include desktop { font-size: $font-size-xx-lg; }
		@include desktop-sm { font-size: $font-size-x-lg; }
	}

	.amount {
		display: inline-block;
		background: $off-white-dark;
		color: $body-txt-color;
		width: 100%;
		font-size: $heading-size-sm;
		text-align: center;
		clip-path: polygon(0 5%, 100% 0, 100% 100%, 0 98%);
		-webkit-clip-path: polygon(0 5%, 100% 0, 100% 100%, 0 98%);

		@include tablet { font-size: $heading-size-lg; }
		@include desktop { font-size: $heading-size-x-lg; }
		@include desktop-sm { font-size: $heading-size-lg; }
	}

	.label-pseudo-wrapper {
		display: inline-block;
		position: relative;

		&:after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			bottom: 102%;
			margin: 0 auto;
			height: 30vh;
			width: 15px;
			background-image: url('~@/assets/images/banner-wire.svg');
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;

			@include mobile {
				width: 10px;
				bottom: 110%;
			}
		}
	}

	.amount-pseudo-wrapper {
		display: inline-block;
		position: relative;

		&:before,
		&:after {
			content: '';
			position: absolute;
			margin: 0 auto;
			height: 30vh;
			width: 15px;
			background-image: url('~@/assets/images/banner-wire.svg');
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;

			@include mobile {
				width: 10px;
				bottom: 100%;
			}
		}

		&:before {
			left: 15%;
			bottom: 95%;
		}

		&:after {
			right: 20%;
			bottom: 98%;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/game/budget/AccountBanner.vue